import React from 'react'
import './styles.css'
import NavBar1 from '../components/NavBar1'
import BarPROJETOS from '../components/BarPROJETOS'
import Projetos from '../components/Projetos'
import Footer from '../components/Footer'
import Helmet from 'react-helmet'
import BarHOME from '../components/BarHOME'

const PageProjetos = () => {
    return (
        <div className='font-al-8'>
            <Helmet>
                <title>Celeste bolos doces & salgados - Blog</title>                
            </Helmet>
    <BarHOME />
            <NavBar1/>
            <BarPROJETOS />
            <Projetos />
            <div className='pt-32'>
                <Footer />
            </div>
        </div>
    )
}
export default PageProjetos